import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { SignedIn, SignedOut } from '@clerk/clerk-react';

import LandingPage from './components/Landing/LandingPage';
import AppLayout from './components/Dashboard/AppLayout';
import SignInPage from './components/auth/SignIn';
import SignUpPage from './components/auth/SignUp';

/**
 * App.jsx — Top-level router for OwensRoot
 *
 * Route access rules (per .clinerules):
 *   Public  : /           — Landing page (no auth required)
 *   Public  : /sign-in/*  — Clerk sign-in flow
 *   Public  : /sign-up/*  — Clerk sign-up flow
 *   Private : /app/*      — App shell (requires authentication)
 *
 * clerkEnabled prop:
 *   false = preview mode (no Clerk key configured).
 */
function App({ clerkEnabled = true }) {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/sign-in/*" element={<SignInPage />} />
        <Route path="/sign-up/*" element={<SignUpPage />} />

        {/* Protected: /app/* — all sub-routes rendered inside AppLayout */}
        <Route
          path="/app/*"
          element={
            clerkEnabled ? (
              <>
                <SignedIn>
                  <AppLayout />
                </SignedIn>
                <SignedOut>
                  <Navigate to="/sign-in" replace />
                </SignedOut>
              </>
            ) : (
              <Navigate to="/sign-in" replace />
            )
          }
        />

        {/* Catch-all — redirect to landing */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
